exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".banner-area[data-v-1b0a96a4]{padding-bottom:35px}.selecter[data-v-1b0a96a4]{text-align:center;padding:35px}.selecter p[data-v-1b0a96a4]{margin-top:20px;font-style:italic}.selecter img[data-v-1b0a96a4]{width:40%;display:block;margin:auto;margin-bottom:25px}.selecter[data-v-1b0a96a4]:first-child{border-right:2px solid rgba(54,54,54,.15)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1b0a96a4","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pages/Start.vue
// module id = 0C7U
// module chunks = 1